// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"f_m ml-3","matrix-table--pad4":"f_n ml-5","matrix-table__title":"f_p","matrix-table__true":"f_q","matrix-table__false":"f_r"};